import { PageHeader } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { EMPTY_ORG, isPlatformOrg, isSaasOrg } from 'domains/orgDomain';
import { useOrg, useOrgId } from 'hooks/useOrg';
import { useTranslation } from 'react-i18next';
import { isRegularOrg } from 'domains/orgDomain';
import CompanyAdminSelect from './CompanyAdminSelect';
import OrgAdminTable from './OrgAdminTable';
import OrgItemForm from './OrgItemForm';
import { useUser } from 'hooks';
import { isOrgAdmin } from 'utils/rbac';
import { Report } from 'app/Layout/Header/Report';
import OrgTypeSelectModal, { OrgTypeEnum } from './OrgTypeSelectModal';
import ImportCustomerOrgModal from './ImportCustomerOrgModal';
import { useState } from 'react';
import './index.less';

const OrgAdmin = () => {
  const { t } = useTranslation();
  const contextOrg = useOrg();
  const regular = contextOrg && isRegularOrg(contextOrg);
  const dispatch = useAppDispatch();
  const curOrg = useAppSelector((state) => state.org.curOrg);
  const orgId = useOrgId();
  const saasOrg = contextOrg && isSaasOrg(contextOrg);

  const isBaseOrg = isPlatformOrg({ id: orgId });
  const user = useUser();
  const sysAdmin = user && user.platformRole === 'SYS_ADMIN';

  const [showOrgTypeModal, setShowOrgTypeModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);

  const handleOrgTypeConfirm = (orgType: OrgTypeEnum) => {
    const baseOrgData = regular
      ? {
          ...EMPTY_ORG,
          parentId: contextOrg?.id,
          company: contextOrg?.company,
        }
      : EMPTY_ORG;

    // 根据选择的类型设置 curOrg
    if (orgType === OrgTypeEnum.SAAS) {
      dispatch.org.setState({
        curOrg: {
          ...baseOrgData,
          orgType: OrgTypeEnum.SAAS,
        },
      });
    } else {
      dispatch.org.setState({
        curOrg: {
          ...baseOrgData,
          orgType: OrgTypeEnum.REGULAR,
        },
      });
    }

    setShowOrgTypeModal(false);
  };

  const pageHeaderExtra = [
    <Report />,
    <CompanyAdminSelect key="company" />,
    (sysAdmin || (saasOrg && isOrgAdmin(user))) && (
      <RevxButton
        key="import"
        brandGreen
        onClick={() => setShowImportModal(true)}
      >
        {sysAdmin
          ? 'Import SAAS Customer Organization'
          : 'Import Customer Organization'}
      </RevxButton>
    ),
    <RevxButton
      key="create"
      brandGreen
      disabled={!!curOrg}
      onClick={() => {
        if (regular) {
          dispatch.org.setState({
            curOrg: {
              ...EMPTY_ORG,
              parentId: contextOrg?.id,
              company: contextOrg?.company,
              orgType: saasOrg ? OrgTypeEnum.CUSTOMER : OrgTypeEnum.REGULAR,
            },
          });
        } else {
          setShowOrgTypeModal(true);
        }
      }}
    >
      {isBaseOrg
        ? t('platform.org.createBaseOrg')
        : saasOrg
        ? t('platform.org.createCustomerOrgFromBase')
        : t('platform.org.createOrgFromBase')}
    </RevxButton>,
  ];
  return (
    <>
      <PageHeader
        title={
          isBaseOrg
            ? t('platform.header.baseOrganizations')
            : t('platform.header.organizations')
        }
        className="platform-page-header"
        ghost={false}
        extra={
          isOrgAdmin(user) && !saasOrg
            ? []
            : regular
            ? pageHeaderExtra.slice(1)
            : pageHeaderExtra
        }
      />

      {curOrg && <OrgItemForm />}

      <OrgAdminTable />

      {/* 组织类型选择弹窗 */}
      <OrgTypeSelectModal
        visible={showOrgTypeModal}
        onCancel={() => setShowOrgTypeModal(false)}
        onConfirm={handleOrgTypeConfirm}
      />

      {/* 导入 Customer Organization 弹窗 */}
      <ImportCustomerOrgModal
        visible={showImportModal}
        onCancel={() => setShowImportModal(false)}
        onSuccess={() => {
          // 导入成功后刷新组织列表
          dispatch.org.getOrgs();
        }}
      />
    </>
  );
};

export default OrgAdmin;
